import { Record, List } from 'immutable';
import { cleanString } from '../utilities';
import MemberExtendedRecord from './MemberExtended';
import OfficeRecord from './Office';

export default class AgentRecord extends Record({
  id: undefined,
  displayType: 'Listing Agent',
  agentStatus: '',
  firstName: '',
  middleName: '',
  lastName: '',
  fullName: '',
  mls: '',
  mlsId: '',
  officeMui: null,
  officeMlsId: '',
  email: '',
  residentialListings: new List(),
  skills: new List(),
  categories: new List(),
  directWorkPhone: '',
  cell: '',
  phone: '',
  office: new OfficeRecord(),
  memberClass: '',
  designations: '',
  extended: new MemberExtendedRecord(),
  numActiveListings: 0,
  numActiveListingsAsSeller: 0,
  numRecentlySoldListings: 0,
  numRecentlySoldListingsAsSeller: 0,
  photo: '',
  website: '',
  memberType: 'realtor'
}) {
  constructor(data) {
    data = data || {};
    data.website = cleanString(data.website);

    if (data.office) {
      data.office = new OfficeRecord(data.office);
    }

    if (data.extended) {
      data.extended = new MemberExtendedRecord(data.extended);
    }

    switch (data.type) {
      case 'listingAgent':
      default:
        data.displayType = 'Listing Agent';
        break;
      case 'coListingAgent':
        data.displayType = 'Co-Listing Agent';
        break;
      case 'sellingAgent':
        data.displayType = 'Selling Agent';
        break;
      case 'coSellingAgent':
        data.displayType = 'Co-Selling Agent';
        break;
    }

    super(data);
  }
}



// WEBPACK FOOTER //
// ./src/records/Agent.js